import { createFileRoute, Navigate } from "@tanstack/react-router";

/**
 * Properties for {@link SubnetRedirect}
 */
type SubnetRedirectProps = {};

/**
 * Redirect page for subnets
 */
function SubnetRedirect(props: SubnetRedirectProps) {
    return <Navigate to={"/a/subnets/approved"} search={{ page: 1 }} />;
}

export const Route = createFileRoute("/_admin/a/subnets/")({
    component: SubnetRedirect,
});
